import { useRef, useState, useCallback } from "react";

export const BeforeAfterSlider = ({ before, after, testId, empty = false }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      className="relative w-full aspect-[4/3] overflow-hidden rounded-2xl select-none cursor-ew-resize bg-[#121814] border border-black/10"
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      {/* AFTER (base) */}
      {empty ? (
        <div className="absolute inset-0 grid place-items-center bg-[#E8F0EB]">
          <div className="text-center">
            <p className="font-mono-t text-[11px] uppercase tracking-widest text-[#05C46B]">Swappable Placeholder</p>
            <p className="font-display font-bold text-2xl text-[#0B0F0C] mt-1">AFTER</p>
          </div>
        </div>
      ) : (
        <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      )}
      <span className="absolute bottom-4 right-4 z-20 font-mono-t text-[10px] uppercase tracking-widest bg-[#00E676] text-[#0B0F0C] px-2.5 py-1 rounded-full">After</span>

      {/* BEFORE (clipped) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        {empty ? (
          <div className="absolute inset-0 grid place-items-center bg-[#121814]">
            <div className="text-center">
              <p className="font-mono-t text-[11px] uppercase tracking-widest text-[#00E676]">Swappable Placeholder</p>
              <p className="font-display font-bold text-2xl text-white mt-1">BEFORE</p>
            </div>
          </div>
        ) : (
          <img src={before} alt="before" className="w-full h-full object-cover" />
        )}
        <span className="absolute bottom-4 left-4 font-mono-t text-[10px] uppercase tracking-widest bg-[#0B0F0C] text-white px-2.5 py-1 rounded-full">Before</span>
      </div>

      {/* handle */}
      <div className="absolute top-0 bottom-0 z-30 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.1)]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg grid place-items-center">
          <div className="flex gap-1">
            <span className="w-1 h-4 bg-[#0B0F0C] rounded-full" />
            <span className="w-1 h-4 bg-[#0B0F0C] rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};
